//react
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

class Authentication extends Component {
	render() {
		const culture = this.props.match.params.culture;
		const section = this.props.match.params.section;
		const key1 = this.props.match.params.key1;
		const key2 = this.props.match.params.key2;

		window.sessionStorage.setItem(culture + 'Key1', key1);
		window.sessionStorage.setItem(culture + 'Key2', key2);

		return (
			<Redirect to={'/' + culture + '/' + section} />
		);
	}
}

export default Authentication;



// WEBPACK FOOTER //
// ./src/pages/authentication/authentication.js